import { type MetaFunction } from '@remix-run/node'

export const meta: MetaFunction = () => [{ title: 'Kogia | Terms of Service' }]

export default function ContributorsTermsOfServiceRoute() {
	return (
		<div className="mx-auto flex max-w-screen-lg flex-col gap-12 p-4 pb-20 md:pt-10">
			<div className="flex flex-col gap-2">
				<h2 className="mb-4 font-serif text-h2">
					<strong className="font-bold">
						Contributor Agreement: Image and Video Donation
					</strong>
				</h2>
				<p>Last updated: April 15th 2024</p>
				<p>
					Please read the following terms and conditions carefully. By
					submitting your images and videos to the Kogia Oceanic Library
					operated by Kogia, you agree to be bound by these terms and
					conditions.
				</p>
				<p>
					<strong className="text-h5 font-bold">
						1. Purpose of Image and Video Donation
					</strong>
				</p>
				<p>
					Your contribution of images and videos to the Kogia Library will
					support our mission to provide small conservation organizations,
					nonprofits, scientists, researchers, activists, and educators with
					access to high-quality marine photography and video content. These
					images and videos will be utilized for various purposes aimed at the
					protection of oceans and marine life.
				</p>
				<p>
					<strong className="text-h5 font-bold">
						2. Usage of Donated Images and Videos
					</strong>
				</p>
				<p>
					The images and videos you donate will be used for the following
					purposes:
				</p>
				<ul className="list-inside list-[auto]">
					<li>Non-commercial videos (educational, conservation, campaigns)</li>
					<li>Nonprofit fundraising (videos, pitches, materials)</li>
					<li>Social Media</li>
					<li>Web usage</li>
					<li>Educational exhibitions</li>
					<li>Educational printed materials</li>
					<li>Awareness/Conservation/Activist Campaigns</li>
					<li>Small-scale art projects</li>
				</ul>
				<p>
					<strong className="text-h5 font-bold">3. Crediting</strong>
				</p>
				<p>
					We greatly value your contribution and are committed to providing
					appropriate credit for your work. We shall adhere to the following
					guidelines for crediting contributors across various platforms and
					uses:
				</p>
				<ul className="list-inside list-[auto]">
					<li>
						The terms and conditions of the licensing agreement for Users
						stipulate that users agree to provide appropriate credit to you (the
						contributor) whenever possible, including:&nbsp;
						<ul className="ml-4 list-inside list-[auto]">
							<li>
								Users shall use the watermarked versions of photos when possible
							</li>
							<li>
								On Social Media: Users shall tag Kogia and credit you (the
								contributor) in the caption when possible.
							</li>
							<li>
								In Videos: If video credits are included, Users shall ensure to
								include Kogia and the contributor of footage within the credits
								when possible. If applicable, Users shall include the
								contributor as well as Kogia in the video description as
								&quot;footage contributed by Kogia (with backlink).&quot;
							</li>
						</ul>
					</li>
				</ul>
				<p>
					<strong className="text-h5 font-bold">4. Termination</strong>
				</p>
				<p>
					You have the right to request the removal of your donated images from
					the Kogia Library at any point.
				</p>
				<p>
					<strong className="text-h5 font-bold">
						5. Membership Duration and Media Usage
					</strong>
				</p>
				<p>
					<strong className="text-h5 font-bold">
						5.1 Membership Duration:
					</strong>
				</p>
				<p>
					Users may access and utilize the media provided by the Kogia Oceanic
					Library only for the duration of their valid membership.
				</p>
				<p>
					<strong className="text-h5 font-bold">5.2 Media Usage:</strong>
				</p>
				<p>
					Upon cancellation of membership, whether initiated by the member or by
					Kogia, the user forfeits all rights to use any media obtained from the
					Kogia Oceanic Library, even if such media was downloaded or accessed
					during the period of valid membership.
				</p>
				<p>
					<strong className="text-h5 font-bold">5.3 Renewal:</strong>
				</p>
				<p>
					Users must renew their membership to continue accessing and using
					media from the Kogia Oceanic Library beyond the initial membership
					period.
				</p>
				<p>
					<strong className="text-h5 font-bold">
						5.4 Termination of Membership:
					</strong>
				</p>
				<p>
					In the event of termination of membership, the user must promptly
					delete or otherwise cease using all media obtained from the Kogia
					Oceanic Library.
				</p>
				<p>
					<strong className="text-h5 font-bold">6. Miscellaneous</strong>
				</p>
				<p>
					Any amendments or modifications to this Agreement must be made in
					writing and signed by both parties.
				</p>
				<p>
					By submitting your images to the Kogia Library, you acknowledge and
					agree to abide by the terms and conditions herein.
				</p>
			</div>
		</div>
	)
}
